<template>
  <data-input-select v-bind="inputBind" v-model="computedValue" />
</template>
<script>
import { call } from 'vuex-pathify';
import { debounce } from 'lodash';
import DataInputSelect from '@/components/DataInputSelect';
export default {
  name: 'DataInputFilterExpressionRelation',
  components: { DataInputSelect },
  props: {
    value: {
      default: null,
    },
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },
    relation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    inputBind() {
      return {
        loading: this.loading,
        readonly: this.loading,
        ...this.$props,
        ...this.$attrs,
        items: this.expressionRelationItems,
      };
    },
    relationDataSource() {
      return this.relation?.data_source;
    },
    relationFilterExpression() {
      return this.relation?.filter_expression;
    },
  },
  data: () => ({
    expressionRelationItems: [],
    loading: false,
    onUpdateAttributes: [],
  }),
  methods: {
    getDatasourceRelationValuesMapping: call('attributesSchema/getDatasourceRelationValuesMapping'),
    getOnUpdateAttributesWatch(expression = this.relationFilterExpression, rxp = /{{([^}]+)}}/g) {
      const queryVars = [];
      let curMatch;
      while ((curMatch = rxp.exec(expression))) queryVars.push(curMatch[1]);
      this.onUpdateAttributes = queryVars.filter(queryVar =>
        Object.prototype.hasOwnProperty.call(this.values, queryVar)
      );
      this.$watch(
        vm => {
          return vm.onUpdateAttributes.reduce((total, current) => {
            total[current] = vm.values[current];
            return total;
          }, {});
        },
        (nV, oV) => {
          if (JSON.stringify(oV || '') === JSON.stringify(nV || '')) return;
          this.computedValue = null;
          if (Object.values(nV).every(value => !!value || value === 0 || value === false))
            this.getExpressionRelationItems();
          else this.expressionRelationItems = [];
        },
        {
          deep: true,
          immediate: true,
        }
      );
    },
    async getExpressionRelationItems(expression = this.relationFilterExpression, vars = this.onUpdateAttributes) {
      this.loading = true;
      for (const queryVar of vars)
        expression = expression.replace(new RegExp('{{' + queryVar + '}}', 'gi'), this.values[queryVar]);
      try {
        const r = await this.getDatasourceRelationValuesMapping({
          datasource: this.relationDataSource,
          payload: { filter_expression: JSON.parse(expression) },
        });
        this.expressionRelationItems =
          r?.[this.relationDataSource]?.[this.relation?.attribute]?.[this.relation?.representation] || [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getExpressionRelationItems = debounce(this.getExpressionRelationItems, 500);
    this.getOnUpdateAttributesWatch();
  },
};
</script>
